import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { AccountBalance } from "../api/types";

/**
 * Такт опроса баланса — ровно TTL кэша на сервере: чаще узел всё равно не
 * спрашивается, реже — карточка отставала бы от сервера на лишний такт.
 */
const POLL_MS = 30_000;

/**
 * Свободный залог аккаунта. `null` — запрос не идёт: карточка закрыта.
 */
export function useAccountBalance(account: string | null) {
  return useQuery<AccountBalance>({
    queryKey: ["account-balance", account ?? ""],
    queryFn: async () => (await api.accountBalance(account ?? "")).balance,
    enabled: account !== null,
    refetchInterval: POLL_MS,
  });
}
